import { Responsive, WidthProvider } from 'react-grid-layout-current';

export default WidthProvider(Responsive);
